import { create } from 'zustand';
import produce from 'immer';

type PricingSource = 'websocket' | 'polling';

interface PricingSourceStore {
	source: PricingSource;
	lastSourceChangeTime: number;
	setSource: (source: PricingSource) => void;
	set: (fn: (s: PricingSourceStore) => void) => void;
	get: () => PricingSourceStore;
}

const usePricingSourceStore = create<PricingSourceStore>((set, get) => ({
	source: 'websocket',
	lastSourceChangeTime: Date.now(),
	setSource: (source: PricingSource) => {
		set(
			produce((s: PricingSourceStore) => {
				if (s.source !== source) {
					s.source = source;
					s.lastSourceChangeTime = Date.now();
				}
			})
		);
	},
	set: (fn) => set(produce(fn)),
	get: () => get(),
}));

export default usePricingSourceStore;
